<template>
  <div class="content main">
    <div class="top">
      <div class="top-wrapper">
        <div class="info">
          <div class="thoughts-container">
            <div class="left">
              <img src="@/assets/images/start/thought4.png" class="thought4" />
              <img src="@/assets/images/start/thought3.png" class="thought3" />
            </div>
            <div class="right">
              <img src="@/assets/images/start/thought1.png" class="thought1" />
              <img src="@/assets/images/start/thought2.png" class="thought2" />
            </div>
          </div>
          <div class="text-container">
            <div class="text-container-inner">
              <img
                src="@/assets/images/start/sexkampen.png"
                class="sexkampen"
              />
              <div class="text-box">
                Vad kan du om sex, reproduktion, rättigheter, dig själv, dina
                medmänniskor och andra livsviktiga grejer? Quizza mot dig själv
                eller andra i det här nyfikna kunskapsspelet!
              </div>
            </div>
          </div>
        </div>
        <RoundedLabel>
          Hur vill du quizza?
        </RoundedLabel>
        <router-link :to="{ name: 'AvatarBuilder' }">
          <RoundedButton>
            Mot dig själv
          </RoundedButton>
        </router-link>
        <router-link :to="{ name: 'PartyStart' }">
          <RoundedButton>
            I partyläge med andra
          </RoundedButton>
        </router-link>
        <AboutSrhrButton />
      </div>
    </div>
    <div class="logo">
      <img src="@/assets/images/start/logo.png" />
    </div>
  </div>
</template>

<script>
import RoundedButton from '@/components/RoundedButton';
import AboutSrhrButton from '@/components/AboutSrhrButton';
import RoundedLabel from '@/components/RoundedLabel';

export default {
  components: {
    RoundedButton,
    RoundedLabel,
    AboutSrhrButton
  }
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-flow: column nowrap;
}
.top {
  flex: 1 1 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}
.logo {
  flex: 0 0 136px;
  max-height: 46px;
  margin-bottom: 20px;
  img {
    width: 136px;
  }
}
.text-container {
  margin-bottom: 40/14 * 1rem;
}
.text-container-inner {
  position: relative;
  margin-top: 30px;

  font-size: 15/375 * 100 + vw;

  border-radius: 30px;
  border-bottom: 5px solid rgba(0, 0, 0, 0.1);
  border-left: 5px solid rgba(0, 0, 0, 0.1);
  border-right: 5px solid rgba(0, 0, 0, 0.1);
}
.sexkampen {
  width: 100%;
  height: auto;
  position: absolute;
  top: -30/14 * 1em;
  left: 0;
}
.text-box {
  border-radius: 30px;
  background-color: #fff;
  padding: 45/14 * 1em 10/14 * 1em 30/14 * 1em;
  font-weight: 700;
  font-style: italic;

  line-height: 150%;
  /* or 22px */

  text-align: center;
}
.thoughts-container {
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  font-size: 1vw;

  .right {
    margin-left: auto;
  }

  .thought2,
  .thought3 {
    margin-left: -17%;
    width: 58/375 * 100 + em;
  }
  .thought1 {
    width: 83/375 * 100 + em;
  }
  .thought4 {
    width: 72/375 * 100 + em;
  }
}

.logo {
  margin-top: auto;
}

@media (min-width: 750px) {
  .thoughts-container {
    font-size: 7.5px;
  }
  .text-container-inner {
    font-size: 30px;
  }
}
</style>
